import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import ErrorPage from './pages/ErrorPage/ErrorPage';
import LaunchHandler from './components/LaunchHandler/LaunchHandler';
export const router = createBrowserRouter([
    {
        path: '/',
        element: (_jsx(LaunchHandler, { children: _jsx(HomePage, {}) })),
        errorElement: _jsx(ErrorPage, {})
    }
]);
